var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutuslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.8 195.16",
    style: {
      enableBackground: "new 0 0 352.8 195.16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0904,
    y1: 53.5086,
    x2: 356.2776,
    y2: 53.5086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.8,76.67c-0.03,5.36-0.5,10.72-1.66,15.99c-1,4.5-2.33,8.91-3.6,13.34c-0.06,0.2-0.08,0.42-0.16,0.61 c-0.11,0.26-0.3,0.47-0.64,0.39c-0.35-0.08-0.39-0.35-0.31-0.64c0.35-1.35,0.54-2.73,0.76-4.11c1.44-9.32,0.75-18.5-1.85-27.54 c-2.46-8.55-6.29-16.43-11.7-23.51c-2.78-3.63-6.09-6.76-9.38-9.88c-3.79-3.62-7.78-7.01-12.16-9.93 c-6.14-4.09-12.77-7.23-19.55-10.06c-12.43-5.2-25.37-8.57-38.7-10.53c-5.52-0.81-11.06-1.32-16.63-1.72 c-8.11-0.59-16.23-0.56-24.32-0.18c-10.37,0.48-20.71,1.53-30.93,3.5c-2.53,0.49-5.08,0.93-7.67,1.07 c-1.66,0.1-2.97-0.43-4.17-1.54c-3.12-2.9-6.31-5.73-9.44-8.62c-1.19-1.1-2.39-2.2-3.58-3.31h149.13 c6.2,3.74,12.05,8.01,17.51,12.89c10.01,8.94,17.83,19.45,22.86,31.93c2.88,7.16,4.71,14.59,5.62,22.27 C352.61,70.28,352.82,73.5,352.8,76.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.5046,
    y1: 156.8501,
    x2: 315.3546,
    y2: 156.8501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.27,195.16H63.48c-4.29-3.28-8.77-6.34-12.53-10.28c-7.91-8.3-13.77-17.75-16.18-29.11 c-1.73-8.19-1.53-16.36,0.32-24.5c0.77-3.4,1.62-6.79,2.42-10.19c0.23-0.97,0.65-1.83,1.36-2.54c0.71,0.24,0.41,0.77,0.35,1.22 c-0.42,3.19-0.7,6.38-0.49,9.6c0.53,8.11,3.36,15.36,8.01,21.94c5.35,7.57,12.44,13.18,20.25,17.98 c8.89,5.45,18.51,9.14,28.61,11.65c7.26,1.8,14.61,3.01,22.04,3.89c7.36,0.88,14.74,1.24,22.14,1.21 c4.82-0.01,9.64-0.23,14.45-0.49c2.25-0.12,4.05,0.5,5.71,2.03C162.7,190.12,165.48,192.64,168.27,195.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.152,
    y1: 129.0403,
    x2: 205.9839,
    y2: 129.0403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.86,195.16H36.23c-1.56-1.28-3.08-2.61-4.59-3.96c-2.91-2.62-5.82-5.23-8.62-7.97 c-7.15-7.01-12.38-15.29-16.27-24.45c-3.34-7.88-5.5-16.07-6.35-24.62c-1.19-11.85,0.35-23.37,3.72-34.73 c3.05-10.28,7.97-19.65,13.82-28.57c1.68-2.57,3.3-5.18,5.06-7.94c5,4.55,9.8,8.92,14.6,13.3c2.73,2.49,5.42,5.04,8.21,7.47 c0.8,0.7,0.75,1.1,0.15,1.84c-3.25,3.95-6.07,8.2-8.72,12.56c-6.41,10.54-11.16,21.74-13.08,33.99c-0.71,4.47-1.13,9.01-0.9,13.55 c0.49,9.44,2.77,18.44,6.8,27.01c3.71,7.89,8.72,14.8,14.99,20.82C45.65,194.03,46.25,194.6,46.86,195.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9173,
    y1: 84.7456,
    x2: 356.5164,
    y2: 84.7456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.72,24.76c2.11,0.03,4.08,0.67,6.05,1.28c11.74,3.65,22.95,8.44,33.08,15.52 c10.91,7.62,19.26,17.4,24.52,29.67c2.44,5.68,3.76,11.64,4.16,17.84c0.75,11.5-2.03,22.26-6.39,32.74 c-1.76,4.21-4.21,8.04-6.68,11.85c-1.98,3.05-3.97,6.09-5.96,9.14c-0.19,0.29-0.38,0.59-0.61,0.86c-1.16,1.36-2,1.45-3.36,0.23 c-2.45-2.19-4.85-4.43-7.28-6.64c-3.92-3.58-7.89-7.11-11.76-10.74c-3.46-3.25-2.8-2.6-0.6-5.66c4.4-6.14,8.84-12.23,12.27-19 c4.16-8.21,6.93-16.77,6.8-26.07c-0.15-11.12-3.91-20.9-11.31-29.23c-7.77-8.74-17.32-14.9-28.09-19.3 C272.88,26.56,271.19,25.94,269.72,24.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9246,
    y1: 98.0225,
    x2: 356.5166,
    y2: 98.0225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.69,28.03c-38.82-0.03-70.06,31.44-70.13,69.88c-0.06,39.8,32.71,70.53,70.04,70.1 c37.63,0.39,69.05-30.39,70.02-68.01C248.64,60.6,216.97,28.06,177.69,28.03z M177.5,163.39c-35.5,0.15-65.33-28.86-65.28-65.36 c0.04-36.79,30.01-65.32,65.36-65.33c36.27-0.01,66.04,29.92,65.4,66.57C242.37,134.68,213.05,163.65,177.5,163.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9173,
    y1: 97.7938,
    x2: 356.5164,
    y2: 97.7938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.09,120.17c-3.51,11.55-11.42,18.38-23.16,20.85c-5.39,1.13-10.8,0.97-16.2-0.01 c0.33-1.25,1.52-0.13,2.07-0.76c2.79-0.26,5.54-0.66,8.13-1.82c5.57-2.49,7.06-6.87,6.4-12.32c-0.76-6.2-4.22-10.61-9.18-14.11 c-2.88-2.02-6.14-3.32-9.13-5.13c-4.61-2.79-9.19-5.6-13.16-9.29c-3.23-3.01-4.84-6.83-5.73-10.96 c-1.87-8.68,1.21-15.97,6.93-22.28c4.77-5.26,10.94-8.05,17.84-9.47c7.02-1.45,13.98-1.6,20.9,0.49c3.24,0.98,6.21,2.51,8.85,4.65 c0.63,0.51,1.02,1.01,1.01,1.9c-0.07,5.53-0.06,11.06-0.09,16.58c-0.14,0.2-0.27,0.18-0.4-0.01c-1.81-4.48-3.93-8.79-7.08-12.52 c-3.07-3.63-6.62-6.56-11.19-8.14c-6.94-2.41-13.61,1.53-16.06,7.67c-1.56,3.91-0.69,7.7,1.85,11.06c2.45,3.24,5.72,5.49,9.2,7.48 c5.64,3.23,11.27,6.46,16.88,9.72c2.93,1.7,5.46,3.93,7.6,6.53C208.24,106.19,209.28,112.96,207.09,120.17z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutuslogo);
export default __webpack_public_path__ + "static/media/aboutuslogo.768443100a11ae94b2d8091eedfc08d6.svg";
export { ForwardRef as ReactComponent };